import cx from "classnames";
import ButtonComponent, { ButtonVariant } from "components/Button";

import styles from "./Button.module.scss";

interface ButtonProps {
  variant?: ButtonVariant;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const Button = ({
  variant = "subtle",
  children,
  className,
  disabled,
  onClick,
}: ButtonProps) => {
  return (
    <ButtonComponent
      size="small"
      variant={variant}
      state={disabled ? "disabled" : "default"}
      className={cx(styles.button, styles[variant], className)}
      onClick={onClick}
    >
      {children}
    </ButtonComponent>
  );
};

export default Button;
